/**
 * useQualificationListScreen.js
 * -----------------------------
 * Headless Hook for Qualification Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterList } from '../../common/useMasterList';
import * as qualificationApi from '../api/qualificationApi';
import { useExportJob } from '../../../../hooks/useExportJob';
import { executePrintReport } from '../../../../utils/printReportUtil';

export function useQualificationListScreen() {
  const master = useMasterList({
    entityName: 'Qualification',
    apiClient: qualificationApi.qualificationClient,
    fetchList: qualificationApi.listQualifications,
    archiveItem: qualificationApi.archiveQualification,
    deleteItem: qualificationApi.deleteQualification,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'qualification',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    } else if (toolKey === 'print') {
      executePrintReport({
        title: 'Qualification Master Registry',
        subtitle: 'Enterprise Academic & Professional Qualifications',
        columns: [
          { header: 'ID', accessor: 'id' },
          { header: 'Qualification Name', accessor: 'name' },
          { header: 'Abbreviation / Code', accessor: 'short_name' },
          { header: 'Status', accessor: 'status' },
          { header: 'Created Date', accessor: 'created_on' },
        ],
        rows: master.state.rows || [],
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
